import { render, staticRenderFns } from "./ReviewBankcard.vue?vue&type=template&id=e641bd52&scoped=true"
import script from "./ReviewBankcard.vue?vue&type=script&lang=js"
export * from "./ReviewBankcard.vue?vue&type=script&lang=js"
import style0 from "./ReviewBankcard.vue?vue&type=style&index=0&id=e641bd52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e641bd52",
  null
  
)

export default component.exports